class LoginController {
  /* @ngInject */
  constructor($log, $state, Auth, Notifications, ENV) {
    Object.assign(this, {
      Auth,
      Notifications,
      $state,
      $log,
      user: {},
      error: "",
    });
  }

  login() {
    this.error = "";
    this.loggingIn = true;
    this.Auth.login(this.user).then(res => {
      this.$state.go('visits');
    }).catch(err => {
      if (err && err.message && err.message === 'Forbidden') {
        this.error = this.Notifications.auth.forbidden;
      } else if (err.status === 403) {
        this.error = this.Notifications.auth.loginLockout;
      } else if (err.status === 401 || err.status === 410) {
        this.error = this.Notifications.auth.loginFailed;
      } else if (err.status === 409) {
        this.error = err.data.message.summary;
      } else if (err.status === 503) {
        this.$state.go('login');
      }

      if(err.data.message){
        this.error = err.data.message
      }
    }).finally(() => {
      this.loggingIn = false;
    });
  }
}

LoginController.$inject = ["$log", "$state", "Auth", "Notifications", "ENV"];
angular.module('pims').controller('LoginController', LoginController);
